// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1qQci","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2i0EY","obliqueLine":"membershipbadge_obliqueLine__20hm4"};